import { useState, useEffect } from "react";

export function useMobileAgent() {
  const checkIsMobile = () => {
    // Check both user agent AND screen width to detect mobile devices
    const userAgentCheck =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    // Consider devices with width less than 1024px as portable devices
    const screenSizeCheck = window.innerWidth < 768;

    // Return true if either condition is met
    return userAgentCheck || screenSizeCheck;
  };

  const [isMobile, setIsMobile] = useState(checkIsMobile());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}

// function isLikelyMobileInDesktopMode() {
//   const ua = navigator.userAgent;
//   const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
//   const isMobileUA = /Mobi|Android|iPhone|iPad/i.test(ua);
//   const isDesktopUA = !isMobileUA;

//   const screenIsSuspiciouslySmall = Math.min(window.innerWidth, window.innerHeight) < 850;

//   // optional: check if devicePixelRatio is high (often the case on phones)
//   const isHighDPR = window.devicePixelRatio >= 2;

//   return (
//     hasTouch &&
//     isDesktopUA &&
//     screenIsSuspiciouslySmall &&
//     isHighDPR
//   );
// }
